import * as d3 from 'd3';

import { BandFormat } from './BandFormat';
import { whiteBackgroundColor, whiteTextColor } from '../../../../common/constants';

export function renderBands(selection: d3.selection.Update<{ bands: BandFormat[] }>) {
    const dataBound = selection.selectAll('.band')
        .data(d => d.bands);
    dataBound.exit()
        .remove();
    const enterSelection = dataBound.enter()
        .append('g')
        .classed('band', true);
    enterSelection.append('path')
        .style('fill', whiteBackgroundColor); // for transition purpose
    dataBound.select('path')
        .attr('d', (d, i) => d.arc)
        .transition()
        .style('fill', d => d.color)//d.isCurrent ? d.color : d.color ? d3.hsl(d.color).brighter(1).toString() : null)
        .attr('class', d => d.classed)
        .style('stroke', whiteTextColor)
        .style('stroke-width', '1px');
}